import React from 'react';
import { ArrowLeft, Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';

export default function LegalLayout({ title, children }) {
  const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#24574E] font-body text-[#F5F3EE] selection:bg-[#F9D965]/20 selection:text-[#F9D965]">
      {/* Mini Nav */}
      <nav className="fixed w-full z-50 bg-[#24574E]/80 backdrop-blur-lg border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-3 group"
          >
            <div className="w-8 h-8 bg-[#F9D965] rounded-full flex items-center justify-center text-[#24574E] transition-transform group-hover:scale-110">
              <Star size={16} fill="currentColor" />
            </div>
            <span className="text-xl font-bold tracking-tight uppercase">SuperAsso</span>
            <span className="px-1.5 py-0.5 text-[10px] font-bold tracking-widest uppercase border border-white/20 rounded text-white/40">
              Beta
            </span>
          </button>
          
          <button 
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm font-bold opacity-60 hover:opacity-100 transition-opacity"
          >
            <ArrowLeft size={16} />
            Retour
          </button>
        </div>
      </nav>

      <main className="pt-40 pb-32 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-5xl md:text-7xl mb-16 serif-display text-[#F9D965]">
            {title}
          </h1>
          
          <div className="space-y-12 text-lg text-[#F5F3EE]/80 leading-relaxed">
            {children}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
